var map = {
	"./dice-1.svg": "./src/assets/svg/dice-items/dice-1.svg",
	"./dice-2.svg": "./src/assets/svg/dice-items/dice-2.svg",
	"./dice-3.svg": "./src/assets/svg/dice-items/dice-3.svg",
	"./dice-4.svg": "./src/assets/svg/dice-items/dice-4.svg",
	"./dice-5.svg": "./src/assets/svg/dice-items/dice-5.svg",
	"./dice-6.svg": "./src/assets/svg/dice-items/dice-6.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg/dice-items sync recursive ^\\.\\/dice\\-.*\\.svg$";